function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import React, { Fragment } from "react";
import { ProductCard, AdContainer, TopPickCarousel, AdContainerDesktop } from "../../index.js";
import { getLocalStorageItem } from "@tkww/ads-content-component-fashion-stylematch/utils/common";
import { QUIZ_FEW_RESULTS_TYPE_BUDGET, QUIZ_FEW_RESULTS_TYPE_FRIENDLY, QUIZ_FEW_RESULTS_TYPE_KEY } from "@tkww/ads-content-component-fashion-stylematch/hooks/use-quiz";
var QUIZ_FEW_RESULTS_HEADER_FRIENDLY = "Styles that fit your look";
var QUIZ_FEW_RESULTS_HEADER_BUDGET = "Budget-friendly finds";
export var shouldItRenderAd = function shouldItRenderAd(active, current_position, starts_after, repeats_after) {
  var adPosOffset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  starts_after = starts_after + adPosOffset;
  if (active === false) {
    return false;
  }
  if (current_position < starts_after) {
    return false;
  }
  if (current_position === starts_after) {
    return true;
  }
  return (current_position - starts_after) % repeats_after === 0;
};
export var calculateLastRowEmptySlots = function calculateLastRowEmptySlots(layoutProps, productsLength) {
  if (layoutProps.is_mobile) {
    var cardsPerRow = 2;
    return productsLength % cardsPerRow;
  } else {
    var _cardsPerRow = 3;
    var numberOfAds = Math.floor(productsLength / layoutProps.settings.starts_after);
    return _cardsPerRow - (productsLength + numberOfAds) % _cardsPerRow;
  }
};
var renderProductCard = function renderProductCard(index, parsedProduct, layoutProps, position, favoriteComponent, modalComponent, modalEntryPoint, modalCtaUrl) {
  return /*#__PURE__*/React.createElement(ProductCard, {
    key: index,
    index: index,
    imageProps: parsedProduct.imageProps,
    product: parsedProduct,
    modalComponent: modalComponent,
    modalEntryPoint: modalEntryPoint,
    modalCtaUrl: modalCtaUrl,
    favoriteComponent: favoriteComponent,
    layoutProps: _objectSpread(_objectSpread({}, layoutProps), {}, {
      source: layoutProps.is_unfiltered_page ? "unfiltered results page" : "filtered results page",
      position: position,
      resultsCount: layoutProps.pagination.total_count,
      pageCount: layoutProps.current_page
    })
  });
};
var renderAdContainer = function renderAdContainer(index, productId, relativePos, currentPage) {
  return /*#__PURE__*/React.createElement(AdContainer, {
    key: "ad" + index,
    viewport: window.innerWidth < 767 ? "mobile" : "desktop",
    id: productId,
    pos: "".concat(relativePos === 20 ? 1 : 2),
    page: "".concat(currentPage),
    sizes: "[[1, 1]]",
    mobileSizes: "[[300, 250], [1, 1], [320, 50]]",
    desktopSizes: "[[1, 1]]",
    style: {
      minHeight: "50px"
    }
  });
};
export var shouldItRenderDesignerHubAd = function shouldItRenderDesignerHubAd(isMobile, origin, index, active) {
  return !isMobile && active && origin === "designer_hub" && index === 23;
};
export var shouldItRenderTopPickCarousel = function shouldItRenderTopPickCarousel(layoutProps, currentPosition, topPickCollectionSize) {
  return !!(window.innerWidth < 767 && layoutProps.origin !== "designer_hub" && layoutProps.is_unfiltered_page && currentPosition === layoutProps.settings.advertiser_dictionary_starts_after && topPickCollectionSize > 0);
};
export var shouldItRenderArticlesComponent = function shouldItRenderArticlesComponent(layoutProps, currentPosition, articleCollectionSize) {
  return window.innerWidth < 767 && layoutProps.origin === "designer_hub" && currentPosition === layoutProps.articleCarouselProps.index && articleCollectionSize > 0;
};
export var mapProductProps = function mapProductProps(products, category) {
  return _mapInstanceProperty(products).call(products, function (product, index) {
    return {
      id: product.id,
      index: index,
      designerName: product.designer.name,
      productStyle: product.style || product.name,
      productPricePoint: product.pricePoint,
      priceEstimated: product.priceEstimated,
      showPrice: product.designer.showPrices,
      topPick: product.topPick,
      productUrl: product.productUrl,
      relativeUrl: product.relativeUrl,
      analyticsProps: {
        label: product.designer.name,
        productType: product.dressType,
        productStyle: product.style || product.name,
        designerName: product.designer.name,
        productDesignerId: product.designer.id,
        designerId: product.designer.id,
        designerURL: product.designer.url,
        productId: product.id,
        productFabric: product.fabric,
        productEmbellishments: product.embellishments,
        productNeckline: product.neckline,
        dressId: product.id,
        product: "fashion",
        productSilhouette: product.silhouette,
        productGownLength: product.gownLength,
        productTrainLength: product.trainLength,
        productPricePoint: product.pricePoint,
        productLineItemId: product.lineItemId,
        productTopPick: !!product.topPick,
        productVisible: !!product.visible,
        productSleeves: product.sleeves,
        productDressLength: product.gownLength,
        productWaistStyle: product.waist,
        productContract: product.contractId || "",
        productSize: product.size
      },
      imageProps: {
        id: product.image.id,
        url: product.image.url,
        containerClassName: "result-card-image-container-full",
        imageClassName: "resultCardImageContainerFull",
        image: product.image.url,
        alt: product.description,
        ariaHidden: false,
        desktopWidth: 304,
        desktopHeight: 436,
        mobileWidth: 167,
        mobileHeight: 239,
        smartCrop: false,
        lazy: false,
        show_spinner: true
      },
      favorite_data: {
        url: product.relativeUrl,
        image_id: product.image.id,
        image_url: product.image.url,
        object: product.id,
        application: "fashion",
        category: category,
        name: product.style || product.name,
        content_type: "fashion"
      }
    };
  });
};
export var renderComponentByIndex = function renderComponentByIndex(index, product, layoutProps, modalComponent, modalEntryPoint, modalCtaUrl, favoriteComponent, instagramGalleryComponent, localVendorsComponent, topPickCollection, articlesComponent, retakeBannerComponent, retakeBannerIndexDesktop, retakeBannerIndexMobile) {
  var _layoutProps$settings = layoutProps.settings,
    category = _layoutProps$settings.category,
    active = _layoutProps$settings.active,
    starts_after = _layoutProps$settings.starts_after,
    repeats_after = _layoutProps$settings.repeats_after;
  var _layoutProps$paginati = layoutProps.pagination,
    per_page = _layoutProps$paginati.per_page,
    current_page = _layoutProps$paginati.current_page;
  var currentPosition = (current_page - 1) * per_page + index + 1;
  var retakeBannerIndex = layoutProps.is_mobile ? retakeBannerIndexMobile : retakeBannerIndexDesktop;
  var ad = shouldItRenderAd(active, currentPosition, starts_after, repeats_after);
  var designerHubAd = shouldItRenderDesignerHubAd(layoutProps.is_mobile, layoutProps.origin, index, layoutProps.settings.active);
  var topPickCarousel = topPickCollection && shouldItRenderTopPickCarousel(layoutProps, currentPosition, topPickCollection.length);
  var parsedProduct = mapProductProps([product], category);
  var renderTopPickCarousel = function renderTopPickCarousel() {
    return /*#__PURE__*/React.createElement(TopPickCarousel, {
      products: mapProductProps(topPickCollection),
      key: "carousel" + index,
      favoriteComponent: favoriteComponent,
      layoutProps: layoutProps
    });
  };
  return /*#__PURE__*/React.createElement(Fragment, {
    key: index
  }, designerHubAd && /*#__PURE__*/React.createElement(AdContainerDesktop, {
    id: parsedProduct[0].id,
    page: layoutProps.current_page
  }), index === 6 && !!layoutProps.articlesComponentProps && articlesComponent && articlesComponent(layoutProps.articlesComponentProps), index === 32 && !!layoutProps.instagramGalleryProps && instagramGalleryComponent && instagramGalleryComponent(layoutProps.instagramGalleryProps), index === 40 && !!layoutProps.localStoreFinderProps && localVendorsComponent && localVendorsComponent(layoutProps.localStoreFinderProps), renderProductCard(index, parsedProduct[0], layoutProps, currentPosition, favoriteComponent, modalComponent, modalEntryPoint, modalCtaUrl), index === retakeBannerIndex && retakeBannerComponent, topPickCarousel && renderTopPickCarousel(), ad && renderAdContainer(index, product.id, currentPosition, layoutProps.pagination.current_page));
};
export var friendlyResultsTitle = function friendlyResultsTitle() {
  var friendlyResultsType = getLocalStorageItem(QUIZ_FEW_RESULTS_TYPE_KEY, QUIZ_FEW_RESULTS_TYPE_FRIENDLY);
  if (friendlyResultsType === QUIZ_FEW_RESULTS_TYPE_FRIENDLY) {
    return QUIZ_FEW_RESULTS_HEADER_FRIENDLY;
  } else if (friendlyResultsType === QUIZ_FEW_RESULTS_TYPE_BUDGET) {
    return QUIZ_FEW_RESULTS_HEADER_BUDGET;
  }
  return QUIZ_FEW_RESULTS_HEADER_FRIENDLY;
};
export var renderFriendlyFinds = function renderFriendlyFinds(index, product, layoutProps, totalProducts, lastRowEmptySlots) {
  var _layoutProps$settings2 = layoutProps.settings,
    active = _layoutProps$settings2.active,
    starts_after = _layoutProps$settings2.starts_after,
    repeats_after = _layoutProps$settings2.repeats_after;
  var relativePos = totalProducts + index + 1;
  var adPosOffset = lastRowEmptySlots * -1;
  var ad = shouldItRenderAd(active, relativePos, starts_after, repeats_after, adPosOffset);
  var parsedProduct = mapProductProps([product]);
  return /*#__PURE__*/React.createElement(Fragment, {
    key: index
  }, renderProductCard(index, parsedProduct[0], layoutProps, relativePos), ad && renderAdContainer(totalProducts + index, product.id, relativePos, 1));
};